import { createContext } from "react"

const AudioContext = createContext()

export default AudioContext
